export default __webpack_public_path__ + "b668e9309f595896559a1fb84970a0f0.webp";